import * as yup from "yup";

export const CreateCnFInventoryScheama = yup.object().shape({
  accId: yup.number(),
  plantId: yup.number(),
  quantity: yup.number().required("Quantity is number"),
});

export const UpdateCnFInventoryScheama = yup.object().shape({
  quantity: yup.number().required("Quantity is number"),
});
